import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useLocalePath, useT } from "../i18n";

export default function NotFound() {
  const t = useT();
  const lp = useLocalePath();
  return (
    <section data-testid="not-found-page" className="flex min-h-[80svh] items-end bg-ink pb-24 pt-40 text-white">
      <Helmet>
        <title>{`${t("ui.notFoundTitle")} | HAROON TRADING`}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="container-x">
        <p className="eyebrow text-white/45">404</p>
        <h1 className="h-section font-display mt-5">{t("ui.notFoundTitle")}</h1>
        <p className="mt-5 text-white/60">{t("ui.notFoundBody")}</p>
        <Link to={lp()} className="btn btn-light mt-10" data-testid="not-found-home">{t("ui.backHome")}</Link>
      </div>
    </section>
  );
}
